"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DestinationsList;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MAX_CARDS_NUMBER = 4;
function DestinationsList(_ref) {
  var _data$dlpItems;
  var {
    data
  } = _ref;
  var baseDataTestId = 'DestinationsList';
  var {
    isLessThanXl
  } = (0, _utils.useScreenSize)();
  var dlpItems = (_data$dlpItems = data.dlpItems) !== null && _data$dlpItems !== void 0 ? _data$dlpItems : [];
  var isFadeEffect = dlpItems.length > MAX_CARDS_NUMBER || isLessThanXl;
  return (0, _jsxRuntime.jsxs)(_react.Box, {
    "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Wrapper'),
    children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
      as: "h2"
    }, headingStyle), {}, {
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Title'),
      children: data.title
    })), (0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({}, _objectSpread({}, destinationsListContainerStyles)), {}, {
      sx: _objectSpread({}, isFadeEffect && {
        '&::after': _objectSpread({}, fadeEffectOverlayStyles)
      }),
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'List'),
      children: dlpItems.map(item => (0, _jsxRuntime.jsx)(DestinationCard, {
        destination: item,
        "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Card')
      }, item.title))
    }))]
  });
}
function DestinationCard(_ref2) {
  var {
    destination
  } = _ref2;
  return (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
    children: (0, _jsxRuntime.jsx)(_react.Link, _objectSpread(_objectSpread({
      href: destination.link
    }, linkStyles), {}, {
      children: (0, _jsxRuntime.jsxs)(_atoms.Card, _objectSpread(_objectSpread({}, cardContainerStyles), {}, {
        children: [(0, _jsxRuntime.jsx)(_react.Image, _objectSpread({
          src: (0, _utils.formatAssetsUrl)(destination.picture)
        }, imageStyle)), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, cardTitleStyles), {}, {
          children: destination.title
        }))]
      }))
    }))
  }));
}
var headingStyle = {
  fontSize: '1.8rem',
  fontWeight: '900',
  lineHeight: '2rem',
  color: 'tertiary',
  marginBottom: 'var(--chakra-space-md)'
};
var wrapperStyles = {
  w: {
    mobile: '19.313rem',
    sm: '18.375rem',
    xl: '19.313rem'
  }
};
var linkStyles = {
  cursor: 'default',
  _hover: {
    textDecoration: 'none'
  },
  _focus: {
    textDecoration: 'none',
    boxShadow: 'none'
  },
  _visited: {
    textDecoration: 'none'
  },
  _link: {
    textDecoration: 'none'
  },
  _active: {
    textDecoration: 'none'
  }
};
var destinationsListContainerStyles = {
  overflowY: 'auto',
  pb: '2xl',
  gap: 'lg',
  flexWrap: 'nowrap',
  position: 'relative',
  top: 0,
  left: 0
};
var fadeEffectOverlayStyles = {
  content: '"content"',
  color: 'transparent',
  bottom: '0',
  right: '0',
  position: 'sticky',
  width: '50px',
  background: 'linear-gradient(-90deg, #FFFFFF 0%, rgba(255, 255, 255, 0))'
};
var cardContainerStyles = {
  bgColor: 'baseWhite',
  display: 'flex',
  direction: 'column',
  minH: '11.125rem',
  border: '1px solid var(--chakra-colors-lightGrey4)',
  borderRadius: 'var(--chakra-space-radiusSmall)',
  boxShadow: 'none',
  padding: '0',
  w: {
    mobile: '19.313rem',
    sm: '18.375rem',
    xl: '19.313rem'
  },
  _hover: {
    cursor: 'pointer',
    boxShadow: '0 0 var(--chakra-space-sm) 0 var(--chakra-colors-lightGrey2)',
    transitionProperty: 'border, box-shadow',
    transitionDuration: '0s, 0s',
    transitionTimingFunction: 'ease, ease',
    transitionDelay: '0s, 0s'
  }
};
var cardTitleStyles = {
  p: 'md',
  fontWeight: 700,
  fontSize: 'md'
};
var imageStyle = {
  borderTopRadius: 'var(--chakra-space-radiusSmall)'
};